import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import Tooltip, { Orientation } from '@dojo/widgets/tooltip';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { AudioMiddleware } from '../middleware/audio';

import css from '../css/audio.m.css';

export interface PlayButtonProperties {
	title: string;
	key: string;
	trackNumber: number;
	audio: AudioMiddleware;
}

interface PlayButtonIcache {
	ttPlay: boolean;
	currentTrack: number;
}

const icache = createICacheMiddleware<PlayButtonIcache>();
const factory = create({
	icache,
	theme
}).properties<PlayButtonProperties>();

export const PlayButton = factory(({ properties, middleware: { icache, theme } }) => {
	const { title, key, trackNumber, audio } = properties();
	const themeCss = theme.classes(css);

	return v(
		'div',
		{
			classes: [themeCss.topicAudio]
		},
		[
			w(
				Tooltip,
				{
					open: icache.getOrSet('ttPlay', false),
					orientation: Orientation.bottom
				},
				[
					{
						content: `Play ${title}`,
						trigger: v(
							'div',
							{
								key: `${key}-audio`,
								xqa: `audio ${key}`,
								role: 'button',
								onclick: () => {
									audio.change_track(trackNumber);
								},
								onmouseover: () => {
									icache.set('ttPlay', true);
								},
								onmouseout: () => {
									icache.set('ttPlay', false);
								},
								onfocus: () => {
									icache.set('ttPlay', true);
								},
								onblur: () => {
									icache.set('ttPlay', false);
								}
							},
							[v('i', { classes: ['fa-solid', 'fa-circle-play'] })]
						)
					}
				]
			)
		]
	);
});

export default PlayButton;
